<template>
  <div class="flex">
    <div class="d-flex justify-space-between align-center mb-2">
      <div class="text-h6 font-weight-medium">
        {{ $t('ReservationDetails') }}
      </div>
      <div
        v-if="canEditPreCheckIn"
        class="text-caption pointer mr-3"
        @click="goToPreCheckIn"
      >
        {{ $t('Edit') }} >
      </div>
    </div>
    <div>
      <div class="text-subtitle-2 font-weight-medium">
        {{ $t('WhosComing') }}
      </div>
      <div class="text-caption">{{ totalGuests }} {{ $t('Guests') }}</div>
    </div>
    <div class="my-2">
      <div class="text-subtitle-2 font-weight-medium">
        {{ $t('SpecialRequests') }}
      </div>
      <div v-for="(req, i) in specialRequests" :key="i" class="text-caption">
        {{ req.display }}
      </div>
    </div>
    <div v-if="parkingInfo.has_info">
      <div class="text-subtitle-2 font-weight-medium">{{ $t('Parking') }}</div>
      <div class="text-caption">
        <span class="font-weight-medium">Model:</span>
        <span>{{ parkingInfo.model }}</span>
      </div>
      <div class="text-caption">
        <span class="font-weight-medium">Plate number:</span>
        <span>{{ parkingInfo.license_plate }}</span>
      </div>
      <div v-if="parkingInfo.assigned_parking_desc" class="text-caption">
        <span class="font-weight-medium">Description:</span>
        <span>{{ parkingInfo.assigned_parking_desc }}</span>
      </div>
      <div v-if="parkingInfo.parking_pass_desc" class="text-caption">
        <span class="font-weight-medium">Description:</span>
        <span>{{ parkingInfo.parking_pass_desc }}</span>
      </div>
    </div>
  </div>
</template>

<script>
import pick from 'lodash/fp/pick'
import compose from 'lodash/fp/compose'
import sum from 'lodash/fp/sum'
import values from 'lodash/fp/values'
const sumGuestByInfo = compose(sum, values, pick(['adults', 'kids', 'babies']))
export default {
  name: 'PreCheckInSummary',
  computed: {
    totalGuests() {
      return sumGuestByInfo(this.reservationInfo.guest_count_info)
    },
    specialRequests() {
      const requests = this.reservationInfo.special_requests || {}
      return Object.entries(requests)
        .filter(([_, value]) => {
          if (typeof value === 'boolean') return value === true
          if (typeof value === 'number') return value > 0
          if (typeof value === 'string') return value.trim() !== ''
          return false
        })
        .map(([key, value]) => {
          let display = key
          if (typeof value === 'string') {
            display = `${key} - ${value}`
          } else if (typeof value === 'number') {
            display = `${value} x ${key}`
          }
          return { key, value, display }
        })
    },
    reservationInfo() {
      return this.$store.getters.reservationInfo
    },
    parkingInfo() {
      return this.reservationInfo.car_info || {}
    },
    preCheckIn() {
      return this.$store.getters.currentReservation?.pre_check_in_info
    },
    skipGuestRegistration() {
      return this.preCheckIn?.skip_guest_registration
    },
    completed() {
      return this.preCheckIn?.status === 'Done'
    },
    canEditPreCheckIn() {
      return (
        (this.skipGuestRegistration || this.completed) &&
        !this.preCheckIn?.locked_guest_details
      )
    },
  },
  methods: {
    goToPreCheckIn() {
      this.$router.push({
        name: 'pre-check-in',
        params: { step: '1', id: this.$route.params.id },
      })
    },
    formatRequestText(request) {
      return request.amount >= 2
        ? `${request.amount} X `
        : '' + `${request.key}`
    },
  },
}
</script>

<style scoped></style>
